import { LuChartLine } from 'react-icons/lu';

import { withStroke } from '../../utils/withStroke';

const LineChartUpIcon = withStroke(LuChartLine);

export { LineChartUpIcon };
